async function syncWarrantyItem({ mainWarrantyProductIds = [], warrantyPropertyKey = 'Extended Warranty'} = {}) {
      console.log("SYNCING....")
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
    
        const eligibleItems = cart.items.filter(item =>
          mainWarrantyProductIds.includes(item.product_id)
        );
    
        const totalEligibleQty = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);
    
        const warrantyItem = cart.items.find(
          item =>
            item.properties &&
            item.properties[warrantyPropertyKey] === 'true'
        );
    
        if (totalEligibleQty === 0 && warrantyItem) {
          console.log('Removing warranty item (no eligible products left)');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: warrantyItem.key,
              quantity: 0,
            }),
          });
          $('body').trigger('warranty.sync.removed');
        } else if (warrantyItem && warrantyItem.quantity !== totalEligibleQty) {
          console.log(`Updating warranty item quantity from ${warrantyItem.quantity} to ${totalEligibleQty}`);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: warrantyItem.key,
              quantity: totalEligibleQty,
              properties: warrantyItem.properties,
            }),
          });
          const warrantySelector = document.getElementById('warranty-selector');
          if(window.location.pathname == '/cart') {
            window.location.reload();
          } else {
            $('body').trigger('added.ajaxProduct', warrantySelector);
          }
        }
      } catch (error) {
        console.error('Failed to sync warranty item:', error);
      }
    }
(function () {
    $(document).ready(function () {
        // Product Facts Wrapper
        function initFactsWrapper() {
            const factsWrapper = $(".facts-wrapper");
            if (factsWrapper.length) {
                $(".facts-wrapper").each(function () {
                    if ($(this).hasClass("slick-initialized")) {
                        $(this).slick("unslick")
                    }
                    const slideCount = $(this).find(".product-fact").length;
                    const windowWidth = $(window).width();
                    if (windowWidth <= 768 && slideCount > 1) {
                        $(this).slick({
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            responsive: [
                                {
                                    breakpoint: 991,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        infinite: true,
                                        dots: true
                                    }
                                },

                            ]
                        });
                    }
                    if (windowWidth > 768 && slideCount > 2) {
                        $(this).slick({
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            responsive: [
                                {
                                    breakpoint: 991,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        infinite: true,
                                        dots: true
                                    }
                                },

                            ]
                        });
                    }
                    $(this).show();
                });
            }
        }
        initFactsWrapper();

        // Homepage Promo Slider
        function initPromoWrapper() {
            const promoWrapper = $(".grids-wrapper");
            if (promoWrapper.length) {
                $(".grids-wrapper").show();
                $(".grids-wrapper").slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: true
                            }
                        },
                    ]
                });
            }
        }
        initPromoWrapper();

        // Homepage bubble navigation
        $('#collection-nav-slider').show();
        $('#collection-nav-slider').slick({
            dots: false,
            speed: 500,
            slidesToShow: 8,
            swipe: true,
            slidesToScroll: 8,
            arrows: false,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    arrows: false
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 3.5,
                    infinite: false
                }
            }]
        });

        $(window).on('resize', function () {
            initFactsWrapper();
        });

        // Megamenu Images
        const MegaMenuImagesWrappers = document.querySelectorAll(".MegaMenu__image");
        MegaMenuImagesWrappers.forEach((wrapper)=>{
          let closestMenu = wrapper.closest(".site-nav__item").querySelector(".site-nav__dropdown");
          let right = $(closestMenu).width() + 120;
          $(wrapper).css({
            right: `-${right}px`,
            height: `${$(closestMenu).height() + 18}px`
          });
        });
        $(".MegaMenu_image-main").hover(
            function(){
            const title = $(this).attr("data-title");
            const megamenuImage = $(`.megamenu-wrapper[data-title="${title}"]`);
            if(megamenuImage.length){
              megamenuImage.parent(".MegaMenu__image").css({ display: "block" });
              $(`.megamenu-wrapper[data-title="${title}"]`).addClass("active");
            }
          },
            function(){
              $(".MegaMenu__image").css({display: "none" });
              $(`.megamenu-wrapper`).removeClass("active");
          }
        );

    });
})();

document.addEventListener("DOMContentLoaded", function () {
    // const playButtons = document.querySelectorAll(".js-video__modal");
    // if(playButtons.length > 0) {
    //   playButtons.forEach((playButton)=> playButton.addEventListener("click", openVideoInModal.bind(this), true));
    //   function openVideoInModal(e) {
    //     console.log({e});
    //   }
    // }

  var videoModal = new theme.Modals('VideoPopup-1', 'video-modal-1');
  var videoModal = new theme.Modals('VideoPopup-2', 'video-modal-2');
 // console.log(videoModal)
});;

// // Open modal with video
// function openModal(videoUrl) {
//   var modal = document.getElementById("videoModal");
//   var iframe = document.getElementById("videoIframe");
//   iframe.src = videoUrl; // Set video URL
//   modal.style.display = "flex"; // Show modal
// }

// // Close modal
// function closeModal() {
//   var modal = document.getElementById("videoModal");
//   var iframe = document.getElementById("videoIframe");
//   iframe.src = ""; // Stop video
//   modal.style.display = "none"; // Hide modal
// }

// // Add event listener to close button
// //document.querySelector(".modal__close").addEventListener("click", closeModal);

// // Add event listener to close modal when clicking outside of the modal
// window.onclick = function(event) {
//   var modal = document.getElementById("videoModal");
//   if (event.target == modal) {
//     closeModal();
//   }
// };


// document.addEventListener("DOMContentLoaded", function () {
//     const videoContainers = document.querySelectorAll(".product-feature-video-item");
//     videoContainers.forEach(container => {
//       const isMobile = window.innerWidth <= 768;
//       const video = container.querySelector(isMobile ? ".mobile_video" : ".desktop_video");
//       const playButton = container.querySelector(".play_button");
      
//       var videoElement = document.querySelector(isMobile ? ".video_url.mobile_video" : ".video_url.desktop_video");
//       var videoSrc = videoElement.getAttribute('src');
      
//       if (!video || !playButton) return;
//         playButton.addEventListener("click", function () {
//           console.log(videoSrc);
//           openModal(videoSrc);
          
//             if (video.paused) {
//                 video.play();
//                 playButton.innerHTML = `
//                     <svg fill="#FFFFFF"  aria-label="pause icon" class="pause-icon" height="40px" width="40px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve">
//                             <g>
//                             	<path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
//                             		S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"/><path d="M33,46h8V14h-8V46z M35,16h4v28h-4V16z"/><path d="M19,46h8V14h-8V46z M21,16h4v28h-4V16z"/>
//                             </g>
//                     </svg>
//                 `;
//             } else {
//                 video.pause();
//                 playButton.innerHTML = `
//                     <svg fill="#FFFFFF" width="40px" aria-label="play icon"  height="40px"  version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve">
//                           <g>
//                           	<path d="M45.563,29.174l-22-15c-0.307-0.208-0.703-0.231-1.031-0.058C22.205,14.289,22,14.629,22,15v30
//                           		c0,0.371,0.205,0.711,0.533,0.884C22.679,45.962,22.84,46,23,46c0.197,0,0.394-0.059,0.563-0.174l22-15
//                           		C45.836,30.64,46,30.331,46,30S45.836,29.36,45.563,29.174z M24,43.107V16.893L43.225,30L24,43.107z"/>
//                           	<path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30
//                           		S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"/>
//                           </g>
//                           </svg>
//                 `;
//             }
//         });
//     });
// });

